export const ENUM_COLORS_MAP = {
  _blue: '#1890ff',
  _green: '#52c41a',
  _yellow: '#ffd732',
  _red: '#ff4d4f',
  _origin: '#faad14',
  _purple: '#c174e4',
  _gray: '#a5a5a8',
};
